module.exports = __webpack_public_path__ + "76c6fe8560fc7f0dc487edfe08cc5fbc.png";